<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>
<template>
    <div>
        <vs-card class="p-4 mb-0">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Production Details</h4>
                </div>
                <vs-button
                    color="primary"
                    class="btn mb-4 md:mb-0 mr-1"
                    @click="submitForm"
                    :disabled="data.details.length < 1 || data.components.length < 1"
                >Save</vs-button>
            </div>
            <div class="vx-row mt-5">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Production Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.production_date"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Release Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.release_date"/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Status*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.production_status_id"
                                width="100%"
                                autocomplete
                                disabled
                            >
                                <vs-select-item v-for="(item, index) in statuses" :key="index" :value="item.value" :text="item.label"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.client_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, client)"
                                :disabled="data.details.length > 0"
                                @input="fetched = false"
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.warehouse_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, warehouse)"
                            >
                                <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details" class="pt-base">
                    <vs-button class="mr-4" type="border" @click="addLine">Add</vs-button>
                    <vs-button type="border" :disabled="selected.length < 1" @click="removeLine">Remove</vs-button>
                    <vs-table v-model="selected" :data="data.details" hoverFlat class="mt-base" multiple>
                        <template slot="thead">
                            <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                            <vs-th style="min-width: 200px;">Product ID</vs-th>
                            <vs-th style="min-width: 200px;">Description</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Received Qty</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.line_id" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.product_id"
                                        width="100%"
                                        autocomplete
                                        @input="handleProductChange(tr)"
                                        @input-change="seachProduct($event)"
                                    >
                                        <vs-select-item v-for="(item, index) in products" :key="index" :value="item.id" :text="item.product_code"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.pack_id" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.batch" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <flat-pickr class="w-full" v-model="tr.expired_date" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.qty" @input="handleQtyChange(tr)" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.uom_id"
                                        width="100%"
                                        autocomplete
                                        @input="handleUomChange(tr)"
                                        :disabled="!tr.product_id"
                                    >
                                        <vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.stock_type_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="!tr.product_id"
                                    >
                                        <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.received_qty" disabled/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.base_qty" disabled/>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.base_uom_id"
                                            width="100%"
                                            autocomplete
                                            disabled
                                        >
                                            <vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab label="Components" class="pt-base">
                    <vs-button class="mr-4" type="border" :disabled="data.details.length < 1" @click="reloadComponent">Reload</vs-button>
                    <vs-button class="mr-4" type="border" :disabled="data.details.length < 1" @click="addComponent">Add</vs-button>
                    <vs-button type="border" :disabled="selectedComponent.length < 1" @click="removeComponent">Remove</vs-button>
                    <vs-table v-model="selectedComponent" :data="data.components" hoverFlat class="mt-base" multiple>
                        <template slot="thead">
                            <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                            <vs-th style="min-width: 70px; width: 70px">Main</vs-th>
                            <vs-th style="min-width: 200px;">Product ID</vs-th>
                            <vs-th style="min-width: 200px;">Description</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.line_id" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-checkbox class="w-full" disabled v-model="tr.main"></vs-checkbox>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.product_id"
                                            width="100%"
                                            autocomplete
                                            @input="handleComponentProductChange(tr)"
                                            @input-change="seachProduct($event)"
                                            :disabled="tr.main"
                                        >
                                            <vs-select-item v-for="(item, index) in products" :key="index" :value="item.id" :text="item.product_code"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.pack_id" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.batch" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <flat-pickr class="w-full" v-model="tr.expired_date" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.qty" @input="handleComponentQtyChange(tr)" :disabled="!tr.product_id || tr.main"/>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.uom_id"
                                            width="100%"
                                            autocomplete
                                            @input="handleComponentUomChange(tr)"
                                            :disabled="tr.main || !tr.product_id"
                                        >
                                            <vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.stock_type_id"
                                            width="100%"
                                            autocomplete
                                            :disabled="tr.main || !tr.product_id"
                                        >
                                            <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.base_qty" disabled/>
                                </vs-td>
                                <vs-td>
                                    <td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.base_uom_id"
                                            width="100%"
                                            autocomplete
                                            disabled
                                        >
                                            <vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                        </vs-select>
                                    </td>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab label="Schedule" class="pt-base">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Supervisor
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.supervisor"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Start Production*
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.start_production"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                End Production*
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.end_production"/>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                <vs-tab label="Notes" class="pt-base">
                    <vs-textarea height="200" class="mt-5" label="Notes" v-model="data.notes"/>
                </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            selected: [],
            selectedComponent: [],
            isLoading: false,
            data: {
                id: null,
                client_id: this.$store.state.user.userconfig.clients.id ? this.$store.state.user.userconfig.clients.id : null,
                warehouse_id: this.$store.state.user.userconfig.warehouses.id ? this.$store.state.user.userconfig.warehouses.id : null,
                reference: null,
                production_date: new Date,
                release_date: null,
                production_status_id: 1,
                supervisor: null,
                start_production: null,
                notes: null,
                details: [],
                components: []
            },

            // Dropdowns
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            statuses: [
                {
                    value: 1,
                    label: 'Unallocated'
                }
            ],
            products: [],
            stock_type: {
                data: [],
                loading: false,
                endpoint: 'master/stocktypes',
                objectKey: 'name'
            },
            fetched: false,
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        back() {
            this.$router.push({name: 'production-order'})
        },
        submitForm() {
            let error = false

            if(!this.data.reference) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: `Please insert reference`
                })

                error = true
            }

            if(!this.data.client_id) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: `Invalid client`
                })

                error = true
            }

            if(!this.data.warehouse_id) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: `Invalid warehouse`
                })

                error = true
            }

            if(!this.data.production_date) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: `Invalid production date`
                })
                
                error = true
            }

            this.data.details.map(item => {
                if(!item.product_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: `Line ${item.line_id} - Invalid product`
                    })

                    error = true
                }

                if(!item.uom_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: `Line ${item.line_id} - Invalid UoM`
                    })
                    
                    error = true
                }

                if(!item.stock_type_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: `Line ${item.line_id} - Invalid stock type`
                    })
                    
                    error = true
                }

                if(item.qty < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: `Line ${item.line_id} - Invalid qty`
                    })
                    
                    error = true
                }
            })

            if(!error) {
                const details = this.data.details.map(detail => {
                    return {
                        line_id: detail.line_id,
                        product_id: detail.product_id,
                        pack_id: detail.pack_id,
                        batch: detail.batch,
                        expired_date: detail.expired_date,
                        qty: detail.qty,
                        uom_id: detail.uom_id,
                        stock_type_id: detail.stock_type_id
                    }
                })

                const components = this.data.components.map(component => {
                    return {
                        main: component.main,
                        line_id: component.line_id,
                        product_id: component.product_id,
                        pack_id: component.pack_id,
                        batch: component.batch,
                        expired_date: component.expired_date,
                        qty: component.qty,
                        uom_id: component.uom_id,
                        stock_type_id: component.stock_type_id
                    }
                })

                const data = {
                    client_id: this.data.client_id,
                    warehouse_id: this.data.warehouse_id,
                    reference: this.data.reference,
                    production_date: this.data.production_date,
                    release_date: this.data.release_date,
                    production_status_id: this.data.production_status_id,
                    supervisor: this.data.supervisor,
                    start_production: this.data.start_production,
                    notes: this.data.notes,
                    details: details,
                    components: components,
                }

                this.isLoading = true
                this.$http.post('valueaddedservice/productionorder/store', this.data)
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Production order added.'
                    })
                    this.$router.push({ name: 'production-order-view', params: { id: res.data.id } })
                })
                .catch(error => this.handleError(error))
            }
        },
        fetchData() {
            this.isLoading = true
            Promise.all([
                this.$http.post('master/clients'),
                this.$http.post('master/warehouses'),
                this.$http.post('master/stocktypes'),
            ])
            .then(this.$http.spread((clients, warehouses, stock_types) => {
                this.isLoading = false
                this.client.data = clients.data.data
                this.warehouse.data = warehouses.data.data
                this.stock_type.data = stock_types.data.data
            }))
            .catch(error => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            })
        },
        addLine() {
            if(this.data.details.length < 1) {
                this.isLoading = true
                this.$http.post('master/product/showbyclient', { client_id: this.data.client_id })
                .then(res => {
                    this.isLoading = false
                    this.products = res.data.data
                    this.pushDetail()
                    this.fetched = true
                })
            }
            else {
                this.pushDetail()
            }
        },
        handleProductChange(detail) {
            const i = this.products.findIndex(p => p.id == detail.product_id)
            const p = this.products[i]
            detail.description = p.description_1
            detail.uoms = p.uoms
            detail.uom_id = p.base_uom.uom_id
            detail.base_uom_id = p.base_uom.uom_id
            detail.qty = 1
            this.handleUomChange(detail)
        },
        handleUomChange(detail) {
            const i = detail.uoms.findIndex(d => d.uom_id == detail.uom_id)
            const u = detail.uoms[i]
            detail.numerator = u.numerator
            detail.denominator = u.denominator
            this.handleQtyChange(detail)
        },
        handleQtyChange(detail) {
            detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
        },
        generateLineIds() {
            this.data.details.map((d, i) => d.line_id = i + 1)
        },
        pushDetail() {
            this.data.details.push({
                line_id: '',
                product_id: '',
                description: '',
                pack_id: '',
                batch: '',
                expired_date: null,
                qty: '',
                uom_id: null,
                stock_type_id: this.$store.state.user.userconfig.stock_type.id ? this.$store.state.user.userconfig.stock_type.id : null,
                received_qty: 0,
                base_qty: '',
                base_uom_id: null,
                numerator: '',
                denominator: ''
            })

            this.generateLineIds()
        },
        removeLine() {
            let indexes = []
            this.selected.map(selected => {
                this.data.details.map((detail, index) => {
                    if(selected.line_id == detail.line_id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)
            indexes.map(i => this.data.details.splice(i, 1))
            this.selected = []
            this.generateLineIds()
            if(this.data.details.length < 1) {
                this.data.components = []
            }
        },
        seachProduct(e) {
            this.$http.post('master/product/showbyclient', { product_code: e.target.value })
            .then(res => {
                res.data.data.map(d => {
                    if(this.products.findIndex(p => p.id === d.id) === -1) {
                        this.products.push(d)
                    }
                })
            })
        },
        reloadComponent() {
            let error = false
            this.data.details.map(detail => {
                if(!detail.product_id) {
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Error',
                        text: `Line ${detail.line_id} - No product selected`,
                        acceptText: 'Close'
                    })

                    error = true
                }
            })

            if(error) { 
                return false
            }

            this.data.components = []
            this.selectedComponent = []
            this.isLoading = true

            const products = this.data.details.map(detail => {
                return {
                    product_id: detail.product_id,
                    base_qty: detail.base_qty,
                }
            })

            this.$http.post('valueaddedservice/getcomponents', { products: products })
            .then(res => {
                this.isLoading = false
                res.data.map(item => {
                    const products = [{
                        id: item.product_id,
                        product_code: item.product.product_code
                    }]
                    
                    if(this.products.findIndex(p => p.id === item.product_id) === -1) {
                        this.products.push({
                            description_1: item.product.description_1,
                            id: item.product.id,
                            product_code: item.product.product_code,
                            uoms: item.product.uoms,
                            uom_id: item.product.base_uom_id,
                            base_uom_id: item.product.base_uom_id,
                            base_uom: item.product.base_uom
                        })
                    }

                    this.data.components.push({
                        line_id: '',
                        main: true,
                        products: products,
                        product_id: item.product_id,
                        product_code: item.product.product_code,
                        description: item.product.description_1,
                        pack_id: '',
                        batch: '',
                        expired_date: null,
                        qty: item.base_qty,
                        uom_id: item.product.base_uom.uom_id,
                        stock_type_id: 1,
                        picked_qty: 0,
                        base_qty: item.base_qty,
                        base_uom_id: item.product.base_uom.uom_id,
                        uoms: item.product.uoms
                    })
                })

                this.generateComponentLineIds()
            })
            .catch(error => this.handleError(error))
        },
        addComponent() {
            let error = false
            this.data.details.map(detail => {
                if(!detail.product_id) {
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Error',
                        text: `Line ${detail.line_id} - No product selected`,
                        acceptText: 'Close'
                    })

                    error = true
                }
            })

            if(error) { 
                return false
            }

            if(!this.fetched) {
                this.isLoading = true
                this.$http.post('master/product/showbyclient', { client_id: this.data.client_id })
                .then(res => {
                    this.isLoading = false
                    this.products = res.data.data
                    this.pushComponent()
                    this.fetched = true
                })
            }
            else {
                this.pushComponent()
            }
        },
        removeComponent() {
            let error = false
            let indexes = []
            this.selectedComponent.map(selectedComponent => {
                this.data.components.map((detail, index) => {
                    if(selectedComponent.line_id == detail.line_id) {
                        if(detail.main) {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: `Line ${detail.line_id} - Cannot delete main component`,
                            })

                            error = true
                        }

                        indexes.push(index)
                    }
                })
            })

            if(error) { 
                return false
            }

            indexes.sort((a, b) => b - a)
            indexes.map(i => this.data.components.splice(i, 1))
            this.selectedComponent = []
            this.generateComponentLineIds()
        },
        generateComponentLineIds() {
            this.data.components.map((d, i) => d.line_id = i + 1)
        },
        pushComponent() {
            this.data.components.push({
                line_id: '',
                main: false,
                product_id: '',
                description: '',
                pack_id: '',
                batch: '',
                expired_date: null,
                qty: '',
                uom_id: null,
                stock_type_id: this.$store.state.user.userconfig.stock_type.id ? this.$store.state.user.userconfig.stock_type.id : null,
                picked_qty: 0,
                base_qty: '',
                base_uom_id: null,
                numerator: '',
                denominator: '',
            })

            this.generateComponentLineIds()
        },
        handleComponentProductChange(component) {
            const i = this.products.findIndex(p => p.id == component.product_id)
            const p = this.products[i]
            component.description = p.description_1
            component.uoms = p.uoms
            component.uom_id = p.base_uom.uom_id
            component.base_uom_id = p.base_uom.uom_id
            component.qty = 1
            this.handleComponentUomChange(component)
        },
        handleComponentUomChange(component) {
            const i = component.uoms.findIndex(d => d.uom_id == component.uom_id)
            const u = component.uoms[i]
            component.numerator = u.numerator
            component.denominator = u.denominator
            this.handleComponentQtyChange(component)
        },
        handleComponentQtyChange(component) {
            component.base_qty = (component.qty / component.denominator) * component.numerator
        },
    },
    mounted() {
        this.fetchData()
    }
};
</script>